import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LocalResourcesCardDetailViewComponent } from '@kp/local-resources/local-resources-card-detail-view/local-resources-card-detail-view.component';
import { LocalResourcesCardMediumViewComponent } from '@kp/local-resources/local-resources-card-medium-view/local-resources-card-medium-view.component';
import { LocalResourcesSearchComponent } from '@kp/local-resources/local-resources-search/local-resources-search.component';
import { SharedModule } from '@kp/shared/shared.module';
import { LocalResourceHoursComponent } from './local-resource-hours/local-resource-hours.component';
import { LocalResourceLocationComponent } from './local-resource-location/local-resource-location.component';
import { NextStepsComponent } from './next-steps/next-steps.component';

@NgModule({
  declarations: [
    LocalResourcesCardDetailViewComponent,
    LocalResourcesCardMediumViewComponent,
    LocalResourcesSearchComponent,
    LocalResourceHoursComponent,
    LocalResourceLocationComponent,
    NextStepsComponent,
  ],
  imports: [CommonModule, SharedModule],
  exports: [LocalResourcesCardDetailViewComponent, LocalResourcesSearchComponent],
})
export class LocalResourcesModule {}
